export default [
  {
    path: '/activity/init',
    name: 'activityInit',
    component: () => import('@/views/activitySignUp/ActivityInit.vue'), // 入口校验页
    props: (route) => ({
      source: route.query.source,
      activityId: route.query.activityId,
      userId: route.query.userId,
      token: route.query.token,
      registration: route.query.registration,
    }),
    meta: {
      title: '',
    },
  },
  {
    path: '/activity-registrationInfor',
    component: () => import('@/views/activitySignUp/RegistrationInfor.vue'),
    name: 'activity-registrationInfor',
    props: true,
    meta: {
      title: '报名信息',
      backgroundClass: 'bg-gray',
      keepAlive: true,
    },
  },
  {
    path: '/activity-seeRegistrationInfo',
    component: () => import('@/views/activitySignUp/SeeRegistrationInfo.vue'),
    name: 'activity-seeRegistrationInfo',
    props: true,
    meta: {
      title: '报名信息',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/activity-pay',
    component: () => import('@/views/activitySignUp/Pay.vue'),
    name: 'activity-pay',
    meta: {
      title: '支付活动费用',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/activity-agreement',
    component: () => import('@/views/activitySignUp/Agreement.vue'),
    name: 'activity-agreement',
    meta: {
      title: '活动协议',
    },
  },
  {
    path: '/activity-registrationStatus',
    component: () => import('@/views/activitySignUp/RegistrationStatus.vue'),
    name: 'activity-registrationStatus',
    props: (route) => ({
      registrationStatus: route.query.registrationStatus || '3',
    }),
    meta: {
      title: '报名信息状态',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/activity-paymentResult',
    component: () => import('@/views/activitySignUp/PaymentResult.vue'),
    name: 'activity-paymentResult',
    meta: {
      title: '支付结果',
      backgroundClass: 'bg-gray',
    },
  },
];
